import PageContainer from '../components/PageContainer';
import Puppies from '../components/Puppies';

const PuppiesPage = () => {
  return (
    <PageContainer>
      <Puppies />
    </PageContainer>
  );
};

export default PuppiesPage; 